module.exports = __webpack_public_path__ + "assets/SupportBtn.667d4f7cb0a104274a7a976cfe5c4c19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/level/SupportBtn.svg
// module id = 862
// module chunks = 0